module.exports = __webpack_public_path__ + "assets/img/spu-img.1a8aaecb.png";